import React from 'react';
import {
  CalendarYearYearlyTimeSelectionInput,
  CohortMetricId,
} from '../../../../api/types-graphql';
import { DashboardConfig } from '../../../../common/components/dashboards/types';
import { Languages } from '../../../../constants';
import { HcSimulationPage } from '../../../../pages/dashboards/HCSimulationDashboard/HcSimulationPage';
import {
  DataFieldWithDataType,
  DataTypes,
  EmployeeDataFields,
} from '../../../../types';

const dashboardId = 'hc-simulation';

const nikkiSegmentFields: DataFieldWithDataType[] = [
  {
    dataType: DataTypes.EMPLOYEE,
    dataField: EmployeeDataFields.AGE_GROUP,
  },
  {
    dataType: DataTypes.EMPLOYEE,
    dataField: EmployeeDataFields.FUNCTION,
  },
  {
    dataType: DataTypes.EMPLOYEE,
    dataField: EmployeeDataFields.CUSTOM_FILTER_3,
  },
];

const nikkiSimulationYearRange: CalendarYearYearlyTimeSelectionInput = {
  start: 2026,
  end: 2035,
};

const NikkiHcSimulationPage = () => (
  <HcSimulationPage
    segmentFields={nikkiSegmentFields}
    simulationMetrics={[CohortMetricId.Pm0417_2SimulatedHeadcountCount]}
    simulationYearRange={nikkiSimulationYearRange}
  />
);

export const NikkiHcSimulationDashboardConfig: DashboardConfig = {
  id: dashboardId,
  title: {
    [Languages.EN]: 'HC Simulation Dashboard',
    [Languages.JA]: '要員計画シミュレーション結果',
  },
  enabled: true,
  qaOnly: true,
  pages: [
    {
      pageId: '1',
      dashboardId,
      pageNumber: 1,
      enabled: true,
      title: {
        [Languages.EN]: 'HC Simulation Page 1',
        [Languages.JA]: '要員計画シミュレーション結果',
      },
      pageOptions: {
        dataView: {
          enabled: false,
        },
        filterTray: {
          enabled: false,
        },
        segmentationLevel1: {
          enabled: false,
        },
        segmentationLevel2: {
          enabled: false,
        },
        benchmark: {
          enabled: false,
        },
        forecast: {
          enabled: false,
        },
        timeOptions: {
          timeSliderEnabled: false,
        },
      },
      gridRows: 1,
      gridCols: 1,
      configType: 'pageComponent',
      pageComponent: NikkiHcSimulationPage,
      link: '/dashboard/headcount-simulation/2',
    },
  ],
};
